export enum ClaimStatus {
  OPEN = "Open",
  CLOSE = "Closed",
  DRAFT = "Draft",
  INPROCESS = "In process",
  PENDINGREVIEW = "Pending review",
  // technical
  NOT_SUBMITTED = "Not submitted",
  DENIED = "Denied",
  CANCELLED = "Cancelled",
  UNKNOWN = "UNKNOWN",
}

enum ClaimStatusColors {
  OPEN = "open",
  CLOSE = "close",
  DRAFT = "draft", // draft == in-process

  DENIED = "denied",
  REVIEW = "review",
  APPROVED = "approved",
}

export const ClaimStatusToUI: {
  [key in ClaimStatus]: { color: ClaimStatusColors; text: string };
} = {
  [ClaimStatus.OPEN]: { color: ClaimStatusColors.OPEN, text: "Open" },
  [ClaimStatus.CLOSE]: { color: ClaimStatusColors.CLOSE, text: "Closed" },
  [ClaimStatus.DRAFT]: { color: ClaimStatusColors.DRAFT, text: "Draft" },
  [ClaimStatus.INPROCESS]: {
    color: ClaimStatusColors.REVIEW,
    text: "In process",
  },
  [ClaimStatus.PENDINGREVIEW]: {
    color: ClaimStatusColors.REVIEW,
    text: "Pending review",
  },
  [ClaimStatus.DENIED]: { color: ClaimStatusColors.CLOSE, text: "Denied" },
  [ClaimStatus.CANCELLED]: {
    color: ClaimStatusColors.CLOSE,
    text: "Cancelled",
  },

  [ClaimStatus.NOT_SUBMITTED]: {
    color: ClaimStatusColors.DRAFT,
    text: "Not submitted",
  },

  [ClaimStatus.UNKNOWN]: { color: ClaimStatusColors.DRAFT, text: "Unknown" },
};
